import { useCallback, useEffect, useState } from "react";
import { ApiError, getApi, ZOD_PARSE_ERROR } from "../../../../utils/api.ts";
import { accessToken } from "../../../../utils/auth.ts";
import { API_PROBATION_ACTIVE_CYCLE } from "../../../../../config/Endpoints";
import { ProbationCycle, ProbationCycleSchema } from "../schemas/index.ts";

export function useActiveProbationCycle() {
    const [cycle, setCycle] = useState<ProbationCycle | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchCycle = useCallback(async (signal?: AbortSignal) => {
        setLoading(true);
        setError(null);

        try {
            const { data } = await getApi<ProbationCycle>(API_PROBATION_ACTIVE_CYCLE, accessToken(), "json", signal);

            if (!data) {
                setCycle(null);
            } else {
                const parse = ProbationCycleSchema.safeParse(data);

                if (!parse.success) {
                    setCycle(null);
                    setError(ZOD_PARSE_ERROR);
                } else {
                    setCycle(parse.data);
                }
            }
        } catch (e) {
            setCycle(null);
            if (e instanceof ApiError && e.status !== 404) {
                setError(e.message);
            }
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        const ac = new AbortController();
        void fetchCycle(ac.signal);

        return () => ac.abort();
    }, [fetchCycle])

    return { cycle, loading, error, refetch: fetchCycle };
}

